export const OFFER_FINANCING_STRUCTURE_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFinancingStructureUpdated";
export const OFFER_FINANCING_STRUCTURE_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFinancingStructureInvalidated";
export const OFFER_MAX_RESIDUAL_VALUE_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFinancialMaxResidualValueComputed";

export const OFFER_FINANCING_PAYMENT_PLAN_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFinancingStructurePaymentPlanInvalidated";

export const FINANCIAL_PRODUCT_ID_ON_SIMULATION_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.FinancialProductIdOnSimulationUpdated";

export const AVAILABLE_FINANCIAL_PRODUCTS_RETRIEVED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.AvailableFinancialProductsRetrieved";

export const OFFER_NEGOTIATE_AMOUNT_COMPUTED = 
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.NegotiateOfferAmountComputed"
